
import login from '../login/login'

export default {
name: 'voucherActivit',
components: {

},
data () {
return {
showGetSuccessDialog: false,
loginShow: false,
}
},
methods: {

loginCallback(status, response) {
console.log(status)
console.log(response)

if(response.code == 0) {
this.$vux.toast.show({
type: 'success',
text: '登录成功'
})
setTimeout(()=>{
this.getVoucher()
},655)
}
},

getVoucher () {
if(!this.$common.getCookie('_token')){
this.loginShow = true
return false;
}
this.$request.post('/couponDetail/getCoupon',{

}).then(data => {
if(this.loginShow) {
this.$router.push({
path: '/voucherActivit'
})
}
if(data.code == 0){
this.showGetSuccessDialog = true
if(this.loginShow) {
setTimeout(()=>{
this.showGetSuccessDialog = true

console.log(this.showGetSuccessDialog)
},50)
}
console.log(this.showGetSuccessDialog)
}else{
if(data.code == 60){
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.obj
})
}
}
}).catch(e => {
if(this.loginShow) {
this.$router.push({
path: '/voucherActivit'
})
}
console.log(e)
if(e.code == 9999){
this.$vux.toast.show({
type: 'warn',
text: e.obj
})
}
})
},
},
created () {

},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/voucherActivit/script.js